<div class="d-inline-flex">
  <ncp-button
    #addHospitalReportButton
    [options]="btnOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.symbols.diagnostics.src"
      width="18"
      height="18"
      alt="Add Hospital Report"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="hospital_report_form"
      name="hospital_report_form"
      [formGroup]="form"
      #frm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown
        #hospitalDD
        [(options)]="hospitalOptions"
      />

      <ncp-input [(options)]="authorInputOptions" />

      <ncp-dropdown
        #specialtyDD
        [(options)]="specialtyOptions"
      />

      <ncp-dropdown
        #hospitalizationDD
        [(options)]="hospitalizationOptions"
      />

      <ncp-date
        #onsetDate
        [(options)]="dateOptions"
      />

      <div>
        <label for="hospitalReportFile" class="form-label">
          {{ 'input.labels.select_file' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          id="hospitalReportFile"
          #documentFileInput
          type="file"
          class="form-control file"
          accept="application/pdf"
          [formControl]="file"
          (change)="onFileSelected($event)"
        />
        @if (documentFileName) {
          <small class="text-muted">
            Selected: {{ documentFileName }}
          </small>
        }
      </div>
    </form>
  </ncp-modal>
</div>
